import { Price } from './price-cap'

export interface SharedAccessBasePrice {
  priceCategoryId: string
  prices: Price[]
}

export interface SharedAccessBeneficiaryPrice {
  priceCategoryId: string
  prices: Price[]
}

export interface SharedAccess {
  maxBeneficiaries?: number
  basePrices?: SharedAccessBasePrice[]
  beneficiaryPrices?: SharedAccessBeneficiaryPrice[]
}
